<!-- 供货商 -->
<template>
    <div class='page_content'>
        <div class="page_content_top">
            <v-button :buttonFlag="false" :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <vSearch @searchData="searchData" @openSearchs="openSearch" :getRequestData=getRequestData v-if="pageShowData.searchList" :searchList="pageShowData.searchList">
                </vSearch>
            </div>
        </div>
        <div class="page_content_center">
            <el-table stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
                <el-table-column label="选择操作" align="center" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.row.index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <!-- 主表单 -->
                <template v-for="(tableValye, tableKey) in pageShowData.dataList">
                    <el-table-column v-if="tableValye.isShow == 1" align="center" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField" show-overflow-tooltip :min-width="tableValye.fieldWeight">
                        <template slot-scope="scope">
                            <span v-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField]
                        }}</a>
                            </span>
                            <span v-else-if="tableValye.fieldType == 'formatter'">
                                <span v-for="(item, index) in tableValye.formatterContent" :key="index">
                                    <el-tag size="mini" v-if="item.key== scope.row[tableValye.entityField]">{{ item.value }}</el-tag>
                                </span>
                            </span>
                            <span v-else>{{ scope.row[tableValye.entityField] }}</span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
        <el-dialog center :title="actionData.title" v-if="showStatus" :visible.sync="showStatus" width="400px">
            <el-form v-if="actionData.type===0" :model="sendDataInfo" ref="sendDataInfo" label-width="140px" class="demo-ruleForm" :inline-message="false" :show-message="false">
                <el-form-item label="客户名称" prop="cmName" :rules="[{ required: true,trigger: ['blur', 'change']}]">
                    <el-input clearable v-model="sendDataInfo.cmName" @clear="clear('cmName,cmId')" @keyup.enter.native="openSearch(3391151360249856, 0, 'cmName', 'cmName,cmId',true)">
                        <el-button @click="openSearch(3391151360249856, 0,'cmName', 'cmName,cmId',true)" slot="append" icon="el-icon-search">
                        </el-button>
                    </el-input>
                </el-form-item>
                <el-form-item label="是否存在押金条" prop="depositSlip" :rules="[{ required: true,trigger: ['blur', 'change']}]">
                    <el-switch v-model="sendDataInfo.depositSlip" :active-value="1" :inactive-value="0"></el-switch>
                </el-form-item>
                <el-form-item label="押金金额" prop="depositMoney" :rules="[{ required: true,trigger: ['blur', 'change']}]">
                    <el-input type="number" v-model="sendDataInfo.depositMoney" clearable></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="sendDataInfo.remark" clearable></el-input>
                </el-form-item>
            </el-form>
            <el-form v-else-if="actionData.type===2" :model="sendDataInfo" ref="sendDataInfo" label-width="140px" class="demo-ruleForm" :inline-message="false" :show-message="false">
                <el-form-item label="扣减金额" prop="depositMoney" :rules="[{ required: true,trigger: ['blur', 'change']}]">
                    <el-input type="number" v-model="sendDataInfo.depositMoney" clearable></el-input>
                </el-form-item>
                <el-form-item label="是否退还押金条" prop="epositSlip" :rules="[{ required: true,trigger: ['blur', 'change']}]">
                    <el-switch v-model="sendDataInfo.epositSlip" :active-value="1" :inactive-value="0"></el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showStatus = false">取 消</el-button>
                <el-button type="primary" @click="onSubmit('sendDataInfo')">保 存</el-button>
            </span>
        </el-dialog>
        <el-dialog center title="查看明细" v-if="seeShow" :visible.sync="seeShow" width="600px">
            <el-table stripe :data="detailsList" height="300" border style="width: 100%" highlight-current-row size="mini">
                <el-table-column align="center" prop="money" label="发生金额" show-overflow-tooltip min-width="120"></el-table-column>
                <el-table-column align="center" prop="depositSlip" label="是否存在押金条" show-overflow-tooltip min-width="120">
                    <template slot-scope="scope">
                        <el-tag size="mini" v-if="scope.row.depositSlip==1">是</el-tag>
                        <el-tag size="mini" type="danger" v-else-if="scope.row.depositSlip==0">否</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="type" label="类型" show-overflow-tooltip min-width="100">
                    <template slot-scope="scope">
                        <el-tag size="mini" type="danger" v-if="scope.row.type==1">扣减</el-tag>
                        <el-tag size="mini" type="success" v-else-if="scope.row.type==0">新增</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="createTime" label="创建日期" show-overflow-tooltip min-width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.createTime">{{ $common.getLocalTime(scope.row.createTime) }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../byComponents/SearchScheme.vue";
import indexJS from './customerDeposit';
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme
    },
    data() {
        //这里存放数据
        return {
            ormId: "",
            tableHeight: 0,
            getRequestData: {},
            returnData: {
                total: 0, // 总条数
                list: [],
            },
            buttonList: indexJS.buttonList,
            pageShowData: indexJS,
            formDataList: [],
            imgUrl: '',
            selectedDataIndex: 0,
            DialogVisible: false,
            parentSearchData: {},
            seTitle: "",
            seWidth: "",
            //-
            showStatus: false,
            sendDataInfo: {
                cmName: "",
                cmId: "",
                depositSlip: 0,
                depositMoney: "",
                remark: "",
                epositSlip: 0,
            },
            actionData: {
                title: "",
            },
            seeShow: false,
            detailsList: [],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
    },
    //方法集合
    methods: {
        init() {
            this.sendDataInfo = {
                cmName: "",
                cmId: "",
                depositSlip: 0,
                depositMoney: "",
                remark: "",
                epositSlip: 0,
            }
        },
        //检索方案
        openSearch(sId, index, type, sField, flag) {
            this.DialogVisible = true;
            this.seId = sId;
            this.sField = sField;
            if (flag) {
                this.parentSearchData[type] = this.sendDataInfo[type];
            } else {
                this.parentSearchData[type] = this.getRequestData[type];
            }
        },
        //检索带回数据
        changeInputModel(val) {
            console.log(val)
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val);
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                if (this.showStatus) {
                    this.sendDataInfo[item] = val[item];
                } else {
                    this.getRequestData[item] = val[item];
                }
            });
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        // 子组件触发
        drawerCancel(commitData) {
            this.showStatus = false
            commitData && this.getDataList()
        },
        // 获取数据列表
        async getPageInfo() {
            var obj = {}
            if (this.pageShowData.searchList) {
                obj = this.$common.getSearchData(this.pageShowData.searchList, 'page', "rows", 30)
            } else {
                obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
            }
            for (const key in obj) {
                this.$set(this.getRequestData, key, obj[key])
            }
            this.getDataList()
        },
        clear(val) {
            if (val) {
                var arr = val.split(",")
                arr.forEach(item => {
                    if (this.showStatus) {
                        this.sendDataInfo[item] = "";
                    } else {
                        this.$set(this.getRequestData, item, "")
                    }
                })
            }
        },
        // 动作集合
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0:
                    this.showStatus = true
                    this.actionData = {
                        title: "新增押金",
                        type: 0,
                    }
                    this.init()
                    break;
                case 1:
                    var olddataInfo = JSON.parse(JSON.stringify(this.returnData.list[this.selectedDataIndex]));
                    if (!olddataInfo) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.showStatus = true
                    this.actionData = {
                        title: "修改押金",
                        type: 1,
                    }
                    break;
                case 2:
                    this.init()
                    this.showStatus = true
                    this.actionData = {
                        title: "押金扣减",
                        type: 2,
                    }
                    break;
                case 3:
                    this.seeShow = true
                    this.detailsList = this.returnData.list[this.selectedDataIndex].detailList
                    break;
                case 15:
                    this.openFormDesign()
                    break;
            }
        },
        onSubmit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.sub()
                } else {
                    this.$message.error("请完善必填项！")
                    return false;
                }
            });
        },
        async sub() {
            let responseData;
            let sendData = {}
            if (this.actionData.type === 0) {
                sendData = {
                    cmId: this.sendDataInfo.cmId,
                    depositSlip: this.sendDataInfo.depositSlip,
                    depositMoney: this.sendDataInfo.depositMoney,
                    remark: this.sendDataInfo.remark,
                }
                responseData = await this.$http.cmDepositadd(sendData)
            } else if (this.actionData.type === 2) {
                sendData = {
                    depositMoney: this.sendDataInfo.depositMoney,
                    epositSlip: this.sendDataInfo.epositSlip,
                    id: this.returnData.list[this.selectedDataIndex].id,
                }
                responseData = await this.$http.cmDepositdeduction(sendData)
            }
            if (responseData.status == 200) {
                this.showStatus = false
                this.getDataList()
                this.$message.success(responseData.message)
            } else {
                this.$message.error(responseData.message)
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },
        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.cmDepositqueryList(this.getRequestData);
            if (responseData.status == 200) {
                this.returnData.list = this.$common.getIndex(responseData.result.list)
                this.returnData.total = responseData.result.total;
                console.log(this.returnData.list);

                this.selectedDataIndex = 0;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取按钮权限
        async getButtonList() {
            // this.buttonList = await this.$common.getActionButton()
            // 
        },
//结束时间改成最后时间
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1
                this.getRequestData.end = time
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo();
        this.imgUrl = this.$store.getters.getConfig.imgUrl;
        this.ormId = sessionStorage.getItem('ormId')

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}
</style>